import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import FormAssessmentTemplate from './form-assessment-template';
import { createMessage } from 'works/legacy/lib/message-helper';
import { CreateAssessmentItemTemplate } from 'works/legacy/graphql/works-list-item-template';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export default function CreateAssessmentTemplate({
  dismiss,
  worksListTemplateId,
  form,
}) {
  const handleMutationCompletion = (response) => {
    if (response.createAssessmentItemTemplate.errors) {
      addErrorsToForm(form, response.createAssessmentItemTemplate.errors);

      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      );
    } else {
      createMessage('success', 'Compliance Item created!');
      dismiss();
    }
  };

  const [createAssessment] = useMutation(CreateAssessmentItemTemplate, {
    onCompleted: handleMutationCompletion,
    onError: () =>
      createMessage(
        'error',
        'Failed to create Compliance Item. Please try again.'
      ),
    refetchQueries: ['WorksListTemplateQuery'],
  });

  const handleSubmit = (values) => {
    createAssessment({
      variables: {
        worksListTemplateId: worksListTemplateId,
        input: values,
      },
    });
  };

  return (
    <FormAssessmentTemplate
      dismiss={dismiss}
      handleSubmit={handleSubmit}
      initialValues={{
        active: true,
        expirationType: 'COMPLETION_DATE',
        daysToExpiry: 365,
      }}
      showExpiration
      form={form}
    />
  );
}

CreateAssessmentTemplate.propTypes = {
  dismiss: PropTypes.func.isRequired,
  worksListTemplateId: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
};
